import React from "react";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { CitySelector } from "./CitySelector";
import "./styles/Header.scss";
import { useCity } from "@/app/providers/CityProvider";

interface HeaderProps {
  onBack: () => void;
  showBack: boolean;
  onOrdersClick: () => void;
  showOrdersButton?: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  onBack,
  showBack,
  onOrdersClick,
  showOrdersButton = true,
}) => {
  const { selectedCity, changeCity, availableCities, isLoading } = useCity();

  return (
    <header className="header">
      <div className="header__left">
        {showBack && (
          <button
            type="button"
            className="header__back-btn"
            onClick={onBack}
            aria-label="Назад"
          >
            ←
          </button>
        )}
      </div>

      <div className="header__center">
        <CitySelector
          selectedCity={selectedCity}
          onCityChange={changeCity}
          availableCities={availableCities}
          isLoading={isLoading}
        />
      </div>

      <div className="header__right">
        {showOrdersButton && (
          <button
            type="button"
            className="header__orders-btn"
            onClick={onOrdersClick}
            aria-label="История заказов"
            title="История заказов"
          >
            <ReceiptLongIcon />
          </button>
        )}
      </div>
    </header>
  );
};
